import ContentLayout from '@/shahrzad-assets/shared_components/ContentLayout'
import { icons } from '@/shahrzad-assets/shared-asstes/icons'
import { buttonTypes } from '@/shahrzad-assets/shared-constants/buttonTypes'
import { colors } from '@/shahrzad-assets/shared-constants/colors'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import { fontSize, fontsWeight } from '@/shahrzad-assets/shared-constants/fonts'
import CustomButton from '@/shahrzad-assets/shared_components/CustomButton'
import PageTitle from '@/shahrzad-assets/shared_components/PageTitle'
import { PaymentSection } from '@/shahrzad-assets/shared_components/style-components/Styles'
import { Col, Row } from 'antd'
import styled from 'styled-components'
import { Divider } from 'antd'
import useUserInfo from '@/hooks/useUserInfo'
import { useContext, useEffect, useRef } from 'react'
import UserQrVcard from '@/components/UserQrVcard'
import { BottomDrawerContext } from '@/shahrzad-assets/shared-contexts/BottomDrawerContext.js'
import Download from '@/shahrzad-assets/shared_components/Download'
import QrQodeGuide from '@/components/QrQodeGuide'
import useUserQr from '@/hooks/useUserQr'
import ShareInSocial from '@/shahrzad-assets/shared_components/ShareInSocial'

const Vcard = () => {
  const { fetchUserInfo, userInfoLoading, userInfo } = useUserInfo()
  useEffect(() => {
    fetchUserInfo()
  }, [])

  const { fetchUserQr, userQrLoading, userQr } = useUserQr()
  useEffect(() => {
    fetchUserQr()
  }, [])

  const componentRef = useRef(null)
  const bottomDrawerCtx = useContext(BottomDrawerContext)
  const btmDrawer = useContext(BottomDrawerContext)

  const handleQrInfo = () => {
    btmDrawer.setComponent(
      <QrQodeGuide title={'راهنمای استفاده از بارکد QR'} />,
    )
    bottomDrawerCtx.show()
  }

  const downloadQRCode = () => {
    bottomDrawerCtx.setComponent(
      <Download
        componentRef={componentRef}
        title={'دانلود کارت شهروندی'}
        fileName='MyVcard'
        setNoneAfterDownload={false}
      />,
    )
    bottomDrawerCtx.show()
  }

  const urlMatch = userQr.match(/URL:(https:\/\/\S+)/)

  return (
    <>
      <PageTitle title='کارت شهروندی من' />

      <ContentLayout>
        <Flex>
          <Title>اسکن بارکد QR</Title>
          <Des>
            برای پرداخت هزینه گوشت تنظیم بازار، خرید از شهروند و دیگر خدمات
            شهرزاد، می‌توانید از بارکد خود استفاده کنید.
          </Des>
        </Flex>

        <UserInfo>
          <WrapperInfo>
            <QrContainer ref={componentRef}>
              <UserQrVcard />
            </QrContainer>

            <Name justify='space-between'>
              <Col>
                <InfoTitle>نام و نام خانوادگی</InfoTitle>
              </Col>
              <Col>
                <p>{userInfo?.vCard?.formattedName}</p>
              </Col>
            </Name>
            <Divider />
            <Row justify='space-between'>
              <Col>
                <InfoTitle>شماره موبایل</InfoTitle>
              </Col>
              <Col>
                <p>{userInfo?.vCard?.telephones[0]?.number}</p>
              </Col>
            </Row>
          </WrapperInfo>
          <ImageWrapper>
            <Image src={icons.CITY}></Image>
          </ImageWrapper>
        </UserInfo>
        <Footer className='fit-width'>
          {urlMatch && urlMatch[1] && (
            <ShareInSocial
              url={urlMatch[1]}
              title='هم‌رسانی'
              text='برای مشاهده اطلاعات روی لینک بزنید'
            >
              <CustomButton
                width='100%'
                height={dimens.BUTTON_LARGE_HEGHIT}
                styletype={buttonTypes.PRIMARY_FILL}
              >
                اشتراک‌گذاری
              </CustomButton>
            </ShareInSocial>
          )}
          <Row gutter={[5, 0]}>
            <Col span={3}>
              <CustomButton
                width='100%'
                height={dimens.BUTTON_LARGE_HEGHIT}
                styletype={buttonTypes.PRIMARY_OUTLINE}
                onClick={handleQrInfo}
              >
                <IconImage>
                  <img src={icons.CIRCLE_INFO} />
                </IconImage>
              </CustomButton>
            </Col>
            <Col span={21}>
              <CustomButton
                width='100%'
                height={dimens.BUTTON_LARGE_HEGHIT}
                styletype={buttonTypes.PRIMARY_OUTLINE}
                onClick={downloadQRCode}
              >
                دانلود بارکد QR
              </CustomButton>
            </Col>
          </Row>
        </Footer>
      </ContentLayout>
    </>
  )
}

export default Vcard

const Title = styled.p`
  text-align: center;
  font-size: ${fontSize.MEDIUM};
  font-weight: ${fontsWeight.BOLD};
`
const Des = styled.p`
  font-size: ${fontSize.NORMAL};
  font-weight: ${fontsWeight.NORMAL};
  color: ${colors.text3};
`
const Flex = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${dimens.SPACING_XXS_NUDGE};
`

const UserInfo = styled.div`
  margin-top: ${dimens.SPACING_M};
  margin-bottom: ${dimens.SPACING_XXL};
  background-color: ${colors.bg3};
  border-radius: ${dimens.BORDER_RADIUS_12};
`
const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${dimens.SPACING_XL};
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  padding: ${dimens.SPACING_XL};
  background-color: ${colors.WHITE};
  cursor: pointer;
  ${PaymentSection}
`
const Image = styled.img`
  width: 100%;
  border-radius: ${dimens.BORDER_RADIUS_12};
`
const IconImage = styled.div`
  img {
    margin: 0;
  }
`
const InfoTitle = styled.div`
  color: ${colors.text3};
`
const WrapperInfo = styled.div`
  padding: ${dimens.SPACING_XL};
`
const ImageWrapper = styled.div`
  border-radius: ${dimens.BORDER_RADIUS_16};
`
const Name = styled(Row)`
  margin-top: ${dimens.SPACING_XL};
`

const QrContainer = styled.div`
  max-width: 16rem;
  margin: 0 auto;
`